export interface AirportContractListGetRecord {
  id: number | null;
  airportName: string | null;
  serviceType: string | null;
  iataCode: string | null;
  fuelSupplier: string | null;
  validSince: string | null;
  validUntil: string | null;
  itpAgent: string | null;
  remarks: string | null;
  showValidOnly: boolean | null;
  contractedAmount: number | null;
  contractedAmountUnitConverterId: number | null;
  contractedValue: number | null;
  contractedValueCurrencyId: number | null;
  paymentTerms: number | null;
  fuelPriceIndexTypeId: number | null;
  fuelPriceIndexId: number | null;
  sapSymbolId: number | null;
  feesLatestValidityPeriodValidSince: string | null,
  feesLatestValidityPeriodValidUntil: string | null,
  papIndexId: number | null;
  indexName: string | null;
  indexValue: string | null;
  indexValueCurrencyId: number | null;
  indexValueUnitConverterId: number | null;
  indexValueUsdT: number | null;
  differential: number | null;
  differentialCurrencyId: number | null;
  differentialUnitConverterId: number | null;
  differentialUsdT: number | null;
  hookUpFee: number | null;
  hookUpFeeCurrencyId: number | null;
  hookUpFeeUnitConverterId: number | null;
  hookUpFeeUsdT: number | null;
  lessThan1000Ltr: number | null;
  lessThan1000LtrCurrencyId: number | null;
  lessThan1000LtrUnitConverterId: number | null;
  lessThan1000LtrUsdT: number | null;
  noFuel: number | null;
  noFuelCurrencyId: number | null;
  noFuelUnitConverterId: number | null;
  noFuelUsdT: number | null;
  outOfHours: number | null;
  outOfHoursCurrencyId: number | null;
  outOfHoursUnitConverterId: number | null;
  outOfHoursUsdT: number | null;
  fuelSupplierId: number | null;
  safBlendCheckbox: boolean | null;
  safBlendPercentage: number | null;
  safIndex: string | null;
  safIndexValue: number | null;
  safIndexValueCurrencyId: number | null;
  safIndexUnitConverterId: number | null;
}
